import { join, resolve } from "path";
import { debounce } from "perfect-debounce";
import { generateRouteTypes } from "../../typed-routes/generateRouteTypes";
import { getRouterRootFromOneOptions } from "../../utils/getRouterRootFromOneOptions";
import { isRouteFileWatchEvent } from "../../utils/routeFileWatch";
function generateFileSystemRouteTypesPlugin(options, routeIndex) {
  var routerRoot = getRouterRootFromOneOptions(options);
  return {
    name: `one-generate-fs-route-types`,
    enforce: "post",
    apply: "serve",
    configureServer(server) {
      var _options_router_experimental, _options_router;
      var appDir = resolve(process.cwd(), getRouterRootFromOneOptions(options));
      var outFile = join(appDir, "routes.d.ts");
      var typedRoutesGeneration = ((_options_router = options.router) === null || _options_router === void 0 ? void 0 : (_options_router_experimental = _options_router.experimental) === null || _options_router_experimental === void 0 ? void 0 : _options_router_experimental.typedRoutesGeneration) || void 0;
      var generateRouteTypesDebounced = debounce(async function() {
        var _options_router2;
        await generateRouteTypes(outFile, routerRoot, (_options_router2 = options.router) === null || _options_router2 === void 0 ? void 0 : _options_router2.ignoredRouteFiles, typedRoutesGeneration, routeIndex.getPaths());
      }, 100);
      var fileWatcherChangeListener = function fileWatcherChangeListener2(type, path) {
        if (isRouteFileWatchEvent({
          event: type,
          filePath: path,
          routerRoot: appDir,
          includeChangeEvents: true
        })) {
          routeIndex.update(type, path);
          return generateRouteTypesDebounced();
        }
      };
      server.watcher.addListener("all", fileWatcherChangeListener);
      return function() {
        var _options_router2;
        generateRouteTypes(outFile, routerRoot, (_options_router2 = options.router) === null || _options_router2 === void 0 ? void 0 : _options_router2.ignoredRouteFiles, typedRoutesGeneration, routeIndex.getPaths());
      };
    }
  };
}
export {
  generateFileSystemRouteTypesPlugin
};
//# sourceMappingURL=generateFileSystemRouteTypesPlugin.js.map
